import { useRef } from "react";
import { useEditMode } from "./EditModeContext";

export default function EditableText({ contentKey, defaultValue, as: Tag = "span", className, children }) {
  const { editMode, content, saveContent } = useEditMode();
  const ref = useRef(null);
  const text = content[contentKey] || defaultValue || (typeof children === "string" ? children : "");

  if (!editMode) {
    return <Tag className={className}>{text}</Tag>;
  }

  return (
    <Tag
      ref={ref}
      className={`${className} outline-none cursor-text rounded-sm transition-all
        hover:outline-dashed hover:outline-1 hover:outline-offset-4 hover:outline-[#7A9E6E80]
        focus:outline-dashed focus:outline-2 focus:outline-offset-4 focus:outline-[#7A9E6E]`}
      contentEditable
      suppressContentEditableWarning
      onBlur={() => {
        const newText = ref.current?.innerText?.trim();
        if (newText && newText !== text) {
          saveContent(contentKey, newText);
        }
      }}
    >
      {text}
    </Tag>
  );
}
